/**
 * DNS substring keywords for Parental Filter “Advanced media”.
 * Intentionally narrow — broad words like "movie" / "cartoon" block too much of the open web.
 */

const KEYWORDS = [
  "anime",
  "manga",
  "manhwa",
  "manhua",
  "donghua",
  "webtoon",
  "hentai",
  "rule34",
  "nhentai",
];

export function getAdvancedMediaEntertainmentKeywords() {
  return [...KEYWORDS];
}

/** Parental-panel “advanced media”; merged with keyword blocklist everywhere VPN rules refresh. */
export function mergeBlockedKeywordsWithAdvancedMedia(baseKeywords, advancedEnabled) {
  const trimmed = (baseKeywords || []).map((k) => String(k || "").trim().toLowerCase()).filter(Boolean);
  const extra = advancedEnabled ? [...KEYWORDS] : [];
  return Array.from(new Set([...trimmed, ...extra]));
}
